import { atom } from "recoil";

import { FieldTypeDto } from "../../dto";

export const fieldTypesAtom = atom<FieldTypeDto[] | undefined>({
  key: "fieldTypesAtom",
  default: undefined,
});
